import { forwardRef } from 'react';

import { type Clip } from '@air/api/types';

export type VideoSeekbarPreviewHlsProps = {
  clip: Pick<Clip, 'height' | 'width'>;
};

export const VideoSeekbarPreviewHls = forwardRef<HTMLVideoElement, VideoSeekbarPreviewHlsProps>(
  ({ clip }, forwardedRef) => (
    <div
      className="relative max-h-[100px] w-[172px] min-w-[172px]"
      style={{
        paddingBottom: `${(clip.height / clip.width) * 100}%`,
      }}
    >
      {/** biome-ignore lint/a11y/useMediaCaption: <We support captions atm> */}
      <video className="absolute inset-0 size-full object-contain" ref={forwardedRef} />
    </div>
  ),
);

VideoSeekbarPreviewHls.displayName = 'VideoSeekbarPreviewHls';
